import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  handleDisable({detail: { value }}) {
    this.buttonTarget.disabled = value
  }
}
